/*
 * サブシステム名：
 * 機能名：日報一覧
 * 表示項目カスタマイズ(花巻運輸)
 */
import D2PRMD0011 from '@/views/PRM/D2PRMD0011.js'

export default {
  extends: D2PRMD0011,
  name: 'NippoListCustomForHNU',
  data: () => ({
    custoMizeHeaders: [
      { text: '編集', value: 'actions', sortable: false, width: '20px' },
      { text: '運行日', value: 'unkoYmdDisp' },
      { text: '配車営業所', value: 'haishaEigyoshoNm' },
      { text: '乗務員', value: 'jomuinJininNmSei' },
      { text: '傭車先', value: 'hacchusakiNm' },
      { text: '自動車表示名', value: 'jidoshaHyojiNm' },
      { text: '車種', value: 'sharyoShashuSbt' },
      { text: '売上営業所', value: 'juchuEigyoshoNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '商品', value: 'hinmeiDisp' },
      { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
      { text: '単価', value: 'tankaDisp' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
      { text: '請求金額合計', value: 'seikyuKingakuGokeiDisp', align: 'end' },
      { text: '支払計上日', value: 'shiharaiYoteiYmdDisp' },
      { text: '支払金額合計', value: 'shiharaiKingakuGokeiDisp', align: 'end' },
      { text: '荷主書面(受)', value: 'chumonshoReceiveZumiFlgDisp', align: 'center' },
      { text: '荷主書面(交付)', value: 'chumonkakuninshoSendZumiFlgDisp', align: 'center' },
      { text: '傭車書面(交付)', value: 'hacchushoSendZumiFlgDisp', align: 'center' },
      { text: '実運送報告', value: 'motoukeHokokuZumiFlgDisp', align: 'center' },
      { text: '運行実績No', value: 'unkoJissekiNo' },
      { text: '受注No', value: 'juchuNo' },
      { text: '#', value: 'meisaiOrder' }
    ]
  }),
  computed: {
  },
  methods: {
  }
}
